// MEMO: import this for IE11.
// MEMO: Swiper 5.4.5 works on IE11.
// import Swiper from "../../node_modules/swiper/js/swiper";

// import the latest version
import Swiper, { Navigation, Pagination, Autoplay } from "swiper";

// configure Swiper to use modules
Swiper.use([Navigation, Pagination, Autoplay]);

// *
// *
// * ----------------------------------------------- */
if (!Number.isNaN) {
  Object.defineProperty(Number, "isNaN", {
    value: function (value) {
      var v = value;
      return v !== value;
    },
  });
}

/*
 *
 * ----------------------------------------------- */
new Swiper(".swiper-news", {
  slidesPerView: 1,
  spaceBetween: 10,
  loop: true,

  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },

  breakpoints: {
    768: {
      slidesPerView: 4,
    },
  },
});
